export default "__VITE_ASSET__CKPNJODd__"